/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListInvitationsQueryResponse,
  ListInvitationsQueryParams,
} from '../../types/ListInvitations'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listInvitations } from '../../clients/listInvitations'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listInvitationsQueryKey = (params?: ListInvitationsQueryParams) =>
  [{ url: '/api/v1/invitations/' }, ...(params ? [params] : [])] as const

export type ListInvitationsQueryKey = ReturnType<typeof listInvitationsQueryKey>

export function listInvitationsQueryOptions(
  params?: ListInvitationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listInvitationsQueryKey(params)
  return queryOptions<
    ListInvitationsQueryResponse,
    ResponseErrorConfig<Error>,
    ListInvitationsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listInvitations(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description List invitations with optional search filter and pagination.
 * @summary List company invitations
 * {@link /api/v1/invitations/}
 */
export function useListInvitations<
  TData = ListInvitationsQueryResponse,
  TQueryData = ListInvitationsQueryResponse,
  TQueryKey extends QueryKey = ListInvitationsQueryKey,
>(
  params?: ListInvitationsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListInvitationsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listInvitationsQueryKey(params)

  const query = useQuery(
    {
      ...listInvitationsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
